var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTeacher)?_c('teacher'):_c('student')
}
var staticRenderFns = []

export { render, staticRenderFns }